import React from "react";
import * as Sentry from "@sentry/react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import decode from "jwt-decode";
import { Loading } from "components/common";
import useMount from "utils/hooks/useMount";
import { setJwt, setUserId, setRoles } from "state/actions/user";
import { setIdleTimer } from "state/actions/idleTimer";

// import { track, identify } from "../../../utils/analytics";

const { REACT_APP_DOMAIN, REACT_APP_BACKEND_URL } = process.env;

const StripeRedirect = () => {
  const { push } = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const updateStateWithToken = (token) => {
    window.localStorage.setItem("jwt", token);
    const { roles = {}, userId } = decode(token);
    dispatch(setJwt(token));
    dispatch(setIdleTimer(true, roles?.admin));
    dispatch(setRoles(roles));
    window.localStorage.setItem("userId", userId);
    dispatch(setUserId(userId));
    // This is for Heap
    // identify(email, { email });
    return userId;
  };

  const { search } = location;
  const params = new URLSearchParams(search);
  const pSessionId = params.get("session_id");
  const pClientSecret = params.get('payment_intent_client_secret');
  const pEmail = params.get("email");

  useMount(() => {
    const handleRedirect = async () => {
      let token;
      let redirect;
      try {
        const jwt = window.localStorage.getItem("jwt");
        if (jwt && (pSessionId || pClientSecret)) {
          const response = await axios.post(
            `${REACT_APP_BACKEND_URL}/login/verify`,
            {},
            { headers: { Authorization: `Bearer ${jwt}` } },
          );
          const { token: newToken, verified } = response.data || {};

          if (verified) {
            const { roles } = decode(newToken || jwt);
            if (roles.user_with_credit_boost_enrolled) {
              token = newToken || jwt;
            }
          }

          if (token) {
            if (pSessionId) { redirect = `/boost?session_id=${pSessionId}`; }
            if (pClientSecret)  { redirect = `/boost?payment_intent_client_secret=${pClientSecret}`; }
          } else {
            redirect = '/login?redirect_url=/boost';
          }
        } else if (pSessionId) {
          const response = await axios.post(
            `${REACT_APP_BACKEND_URL}/stripeLogin`,
            { sessionId: pSessionId },
          );
          token = response.data?.token;
          redirect = response.data?.redirectPath || `/boost?session_id=${pSessionId}`;
        } else if (pClientSecret) {
          const response = await axios.post(
            `${REACT_APP_BACKEND_URL}/stripeLogin`,
            {
              email: pEmail,
              clientSecret: pClientSecret,
            });
          token = response.data?.token;
          redirect = response.data?.redirectPath || `/boost?payment_intent_client_secret=${pClientSecret}`;
        } else {
          redirect = `${REACT_APP_DOMAIN}/boost`;
        }

        if (token) {
          updateStateWithToken(token);
        } else {
          window.localStorage.removeItem("jwt");
        }

      } catch (err) {
        Sentry.captureException(err);
        window.localStorage.removeItem("jwt");
        redirect = err.response?.data?.redirectPath ?? '/login?redirect_url=/boost';
      }

      if (redirect) {
        if (redirect === '/boostLanding') {
          // v1 - remove after backend deploy. backend will send the full url
          window.location.assign(`${REACT_APP_DOMAIN}/boost`);
        } else if (redirect.indexOf('http://') === 0 || redirect.indexOf('https://') === 0) {
          window.location.assign(redirect);
        } else {
          push(redirect);
        }
      } else {
        push('/login?redirect_url=/boost');
      }
    };
    handleRedirect();
  });

  return <Loading boost />;
};

export default StripeRedirect;
